import { MethodCommands, MethodHandler, MethodProperties } from '@lentau/analytics/health-metrics/shared';
import { promoactionSearchHandler } from './purchased-products-list';
import { MethodPropertiesKey } from '../../shared/consts';

export enum ProductMethods {
  PromoactionSearch = 'promoactionSearch',
}
export const PURCHASED_PRODUCT_HANDLER_LIST: MethodHandler = {
  [ProductMethods.PromoactionSearch]: promoactionSearchHandler,
};

export const PURCHASED_PRODUCT_PROPERTIES_LIST: MethodProperties = new Map([
  [
    ProductMethods.PromoactionSearch,
    [
      {
        key: MethodPropertiesKey.TEAM,
        value: MethodCommands.SE,
      },
    ],
  ],
]);
